import { Box, Button, Pagination, Paper } from "@mui/material";
import { Link } from "react-router-dom";
import ContentRight from "shared/molecules/content-right";
import { TypographyHeading } from "shared/molecules/typography-layout";
import { makeStyles } from "@mui/styles";
import { indigo } from "@mui/material/colors";
// import ScheduleFilter from "./filter/intex";
import { useLazyQuery } from "@apollo/client";
import myClassroomClient from "utils/graphql/myclassroom";
import {
  GET_EXAM_SCHEDULES,
  GET_SCHEDULE_FILTER_OPTIONS,
} from "utils/graphql/services/exam-schedule/queries";
import { useEffect, useState } from "react";
import { ScheduleFilter } from "./filter";
import { isEmpty } from "utils/helpers";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { metadataSuccess } from "app-component/slices/metadata-slice";
import ScheduleListingPage from "./table/list-page";
import Loader from "pages/build-test/loader";
import NoDataFound from "shared/molecules/no-data";
// import ScheduleListingPage from "./filter/intex";

const useStyles: any = makeStyles((indigoTheme) => ({
  label: {
    textDecoration: "none",
    textAlign: "center",
    color: indigo[700],
    marginLeft: "80%",
  },
  Btn: {
    backgroundColor: "#3f50b5",
    color: "white",
    width: "90px",
  },
  BtnWrapper: {
    display: "flex",
    gap: "20px",
    justifyContent: "flex-end",
    paddingTop: "10px",
    paddingBottom: "10px",
  },
}));

export const ListPageExamSchedule = () => {
  const classes = useStyles();
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [searchPayload, setSearchPayload] = useState({});
  const dispatch = useAppDispatch();
  const { isLoading, data: metaData }: any = useAppSelector(
    (state) => state.metadataReducer
  );
  const [getScheduleFilterOptions, { loading, error, data: dataFilter }] =
    useLazyQuery(GET_SCHEDULE_FILTER_OPTIONS, {
      client: myClassroomClient,
       fetchPolicy: "no-cache",
    });
  const [
    getExamSchedule,
    { loading: loadingEs, error: errorEs, data: dataEs },
  ] = useLazyQuery(GET_EXAM_SCHEDULES, {
    client: myClassroomClient,
    fetchPolicy: "no-cache",
  });
  const updateMetaData = (
    listData,
    metaKey,
    listData2,
    metaKey2,
    listData3,
    metaKey3
  ) => {
    let metadataList = { ...metaData };
    metadataList[metaKey] = listData;
    metadataList[metaKey2] = listData2;
    metadataList[metaKey3] = listData3;
    dispatch(metadataSuccess(metadataList));
  };

  useEffect(() => {
    getScheduleFilterOptions({ variables: {} });
  }, []);

  useEffect(() => {
    getExamSchedule({ variables: { filter: searchPayload, page, limit } });
  }, [limit,page,searchPayload]);

  useEffect(() => {
    if (!loading && !isEmpty(dataFilter?.getScheduleFilterOptions)) {
      updateMetaData(
        dataFilter?.getScheduleFilterOptions?.branch_ids,
        "college_list_gqf",
        dataFilter?.getScheduleFilterOptions?.class_ids,
        "class_list_gqf",
        dataFilter?.getScheduleFilterOptions?.exam_types,
        "exam_type_gqf"
      );
    }
  }, [dataFilter]);
 const examSchedulesData =dataEs?.getExamSchedules?.schedules
  const showPagination = examSchedulesData?.length === limit;
  const hasNextPage = examSchedulesData?.length === limit;
  return (
    <>
      <TypographyHeading sx={{ mb: 2, mt: 3, fontSize: "35px" }}>
        Schedule Listing Page
      </TypographyHeading>
      <ContentRight>
        <Link to="/exam_schedule/create_exam" className={classes.label}>
          <Button variant="contained">Create Schedule </Button>
        </Link>
      </ContentRight>

      <Paper sx={{ padding: "20px", marginTop: "30px" }}>
        <ScheduleFilter setSearchPayload={setSearchPayload} setPage={setPage} />
      </Paper>
      <Paper sx={{ padding: "20px", marginTop: "30px" }}>
        {loadingEs && <Loader />}
        {!loading && !isEmpty(examSchedulesData) ? (
          <ScheduleListingPage
            examSchedulesData={examSchedulesData}
            limit={limit}
            setLimit={setLimit}
            setPage={setPage}
            page={page}
          />
        ) : (
          <>{!loading && !loadingEs && <NoDataFound message="No Data" />}</>
        )}

          <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            p: 2,
          }}
        >
            <Pagination
              count={hasNextPage ? page + 1 : page} // Show one more page if there might be more data
              page={page}
              onChange={(event, value) => setPage(value)}
              color="primary"
              showFirstButton={page > 1}
              showLastButton={false} // Don't show last button since we don't know total pages
              hidePrevButton={page === 1}
              hideNextButton={!hasNextPage}
            />
        </Box>
      </Paper>
    </>
  );
};
